import React from "react";
import GlaserChart from "@/components/portal/GlaserChart";
import DewPointChart from "@/components/portal/DewPointChart";
import { useI18n } from "@/lib/i18n";
import { LineChart as ChartIcon, Activity } from "lucide-react";

export default function GlaserPage({ metrics, layers, conditions }) {
  const { t } = useI18n();

  return (
    <div className="space-y-4" data-testid="glaser-page">
      <div className="border-2 border-[var(--neon-cyan)] bg-gradient-to-r from-[#0A0A0A] via-[#0F1F22] to-[#0A0A0A] p-5">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 border border-[var(--neon-cyan)] flex items-center justify-center flex-shrink-0">
            <Activity className="w-7 h-7 text-[var(--neon-cyan)]"/>
          </div>
          <div className="flex-1">
            <div className="tech-label text-[var(--neon-cyan)]">EN 13788 · HYGROTHERMAL ANALYSIS</div>
            <h2 className="text-2xl font-bold tracking-tight">{t("glaser.title")}</h2>
            <p className="font-mono text-[11px] text-[#8B8B95] mt-1">{t("glaser.subtitle")}</p>
          </div>
          {metrics && (
            <div className="hidden sm:flex items-center gap-3 ml-auto">
              <div className="text-right">
                <div className="tech-label">U-VALUE</div>
                <div className="font-mono text-2xl font-semibold neon-cyan">{metrics.u_value.toFixed(3)}</div>
              </div>
              <div className="text-right">
                <div className="tech-label">DEW POINT</div>
                <div className="font-mono text-2xl font-semibold" style={{ color: metrics.condensation_risk ? "#FF3B30" : "#39FF14" }}>
                  {metrics.dew_point.toFixed(1)}°C
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {!metrics && (
        <div className="border border-[#1F1F1F] bg-[#141414] p-8 text-center font-mono text-sm text-[#8B8B95]">
          Add layers in the Calculation tab to view Glaser analysis.
        </div>
      )}

      {metrics && (
        <div className="border border-[#1F1F1F] bg-[#141414] p-5">
          <GlaserChart metrics={metrics} layers={layers} dark={true}/>
        </div>
      )}
    </div>
  );
}
